// Exporte une constante

export const competences = [
  { title: "competences.languages", description: "competences.languagesDescription" },
  { title: "competences.communication", description: "competences.communicationDescription" },
  { title: "competences.workEnvironment", description: "competences.workEnvironmentDescription" },
  { title: "competences.leadership", description: "competences.leadershipDescription" },
  { title: "competences.systemsTools", description: "competences.systemsToolsDescription" },
];

export const languages = [
  { title: "languages.clientSide", description: "JavaScript" },
  { title: "languages.serverSide", description: "JavaScript (Node.js), PHP, Java, Python, Apex (Salesforce)" },
  { title: "languages.markup", description: "HTML5" },
  { title: "languages.stylesheet", description: "Sass, CSS3, Twig" },
];

export const experiences = [
  {
    title: "experiences.date1",
    description: 'experiences.description1',
  },
  {
    title: "experiences.date2",
    description: 'experiences.description2',
  },
  {
    title: "experiences.date3",
    description: 'experiences.description3',
  },
  {
    title: "experiences.date4",
    description: 'experiences.description4',
  },
  {
    title: "experiences.date5",
    description: 'experiences.description5',
  },
];

export const formations = [
  {
    title: "formations.date1",
    description: "formations.description1",
  },
  {
    title: "formations.date2",
    description: "formations.description2",
  },
  {
    title: "formations.date3",
    description: "formations.description3",
  },
  {
    title: "formations.date4",
    description: "formations.description4",
  },
  {
    title: "formations.date5",
    description: "formations.description5",
  },
  {
    title: "formations.date6",
    description: "formations.description6",
  },
];

export const technologies = [
  { title: "technologies.uiux", description: "technologies.uiuxDescription" },
  { title: "technologies.wordpress", description: "technologies.wordpressDescription" },
  { title: "technologies.frontend", description: "technologies.frontendDescription" },
  { title: "technologies.backend", description: "technologies.backendDescription" },
  { title: "technologies.frameworks", description: "technologies.frameworksDescription" },
  { title: "technologies.database", description: "technologies.databaseDescription" },
];

export const hobbies = [
  { title: "hobbies.sports", description: "hobbies.sportsDescription" },
  { title: "hobbies.volunteering", description: "hobbies.volunteeringDescription" },
  { title: "hobbies.webNavigation", description: "hobbies.webNavigationDescription" },
  { title: "hobbies.diy", description: "hobbies.diyDescription" },
];
